<template>
  <div class="action-bar">
    <Button
      label="Print Repair Tag"
      @click="generatePDF"
    />
  </div>

  <div
    ref="repairTagContent"
    class="repair-tag-container"
  >
    <!-- QR Code and Basic Info -->
    <div class="repair-tag-content">
      <div class="header">
        <img
          :src="Logo"
          alt="Symphony Logo"
          class="logo"
        >
        <h2 class="repair-label">
          REPAIR TAG
        </h2>
      </div>

      <div class="qr-section">
        <img
          src="/images/qrCode.png"
          alt="Asset QR Code"
          class="qr-code"
        >
      </div>

      <div class="asset-info">
        <div class="info-row">
          <strong>Asset:</strong>
          <span>{{ assetName }}</span>
        </div>
        <div class="info-row">
          <strong>Asset #:</strong>
          <span>{{ assetNumber }}</span>
        </div>
        <div class="info-row">
          <strong>Date:</strong>
          <span>{{ formatDate(repairDate) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Logo from '@/assets/logos/Symphony_Logo_Vertical_RGB.png';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const repairTagContent = ref(null);

// Sample data - in real app this would come from props or store
const assetName = ref('Sample Asset');
const assetNumber = ref('ABC123');
const repairDate = ref(new Date());

const formatDate = (date) => {
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
    });
};

const generatePDF = async () => {
    const content = repairTagContent.value;
    const canvas = await html2canvas(content);
    const imgData = canvas.toDataURL('image/png');
    // Use a smaller page size for labels (100x150mm)
    const pdf = new jsPDF('p', 'mm', [100, 150]);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('repair-tag.pdf');
};
</script>

<style scoped>
.action-bar {
    width: 100mm;
    margin: 0 auto 20px;
    display: flex;
    justify-content: center;
}

.repair-tag-container {
    width: 100mm;
    height: 150mm;
    margin: 0 auto;
    padding: 10mm;
    font-family: Arial, sans-serif;
    color: #333;
    background-color: white;
    border: 1px solid #e0e0e0;
}

.repair-tag-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5mm;
}

.header {
    text-align: center;
    width: 100%;
}

.logo {
    height: 15mm;
    object-fit: contain;
    margin-bottom: 3mm;
}

.repair-label {
    font-size: 16pt;
    font-weight: bold;
    margin: 0;
}

.qr-section {
    display: flex;
    justify-content: center;
    margin: 5mm 0;
}

.qr-code {
    width: 40mm;
    height: 40mm;
    object-fit: contain;
}

.asset-info {
    width: 100%;
    margin-top: 5mm;
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 3mm;
    font-size: 12pt;
}

.info-row strong {
    color: #666;
}
</style>